import React from 'react';
import {
  Box,
  Button,
  Center,
  Flex,
  Margin,
  Padding,
  scrollToRefObject,
  Stack,
  Text,
} from '../../components';

export const HeaderModuleTablet = (props) => {
  let { reference } = props;
  const executeScroll = () => scrollToRefObject(reference);
  return (
    <Flex>
      <Flex flex={2}>
        <Box ratio={0.8} backgroundImage={'images/header-module-picture.jpg'} />
      </Flex>

      <Flex flex={1} backgroundRole="primary">
        <Center height="100%">
          <Padding size={[5, 10, 6, 10]}>
            <Stack size={5}>
              <Text textType="heading2_desktop">Join our team</Text>

              <Text textType="primary2">
                Glossier is giving voice through beauty as a direct-to-consumer
                company that leverages the power of personal narrative to own
                the beauty conversation on the internet.
              </Text>

              <Margin size={[0]}>
                <Center>
                  <Button
                    borderSize={[1]}
                    radius="small"
                    borderRole="grey"
                    backgroundRole="white"
                    onClick={executeScroll}
                  >
                    Learn More
                  </Button>
                </Center>
              </Margin>
            </Stack>
          </Padding>
        </Center>
      </Flex>
    </Flex>
  );
};
